<template>
  <div class="notifications">
    <div class='info-text'>
      <div class="info-text-detail-paragraph">
        <div class="info-text-detail-header">
          <Description title="Bildirimler" description=""/>
        </div>
        <div class="read-all">
          <span v-if="isPolicyNotExists">Yeni bildiriminiz bulunmamaktadır</span>
        </div> 
        <div class="columns is-gapless is-multiline">
          <div class="column is-12" v-for="polItem in policies">
            <router-link :to="{name: 'Policies'}">
              <div class="policy-item" v-if="policies && policies.length > 0">{{ polItem.PoliceNo }}<span> nolu poliçenizin vadesi geçmiş borcu bulunmaktadır.</span></div>
            </router-link>
          </div>
        </div> 
        <div class='divider'></div>
      </div>
    </div>
  </div>
</template>

<script>
import Description from '@/shared/widget/proposal/description'
export default {
  name: 'notifications',
  data () {
    return {
    }
  },
  components: {
    Description
  },
  props: {
    policies: Array
  },
  mounted () {
  },
  methods: {
    readAll: function (e) {
      e.preventDefault()
    },
    openPolicyDetail: function (item) {
      this.$router.push({
        name: 'PolicyDetail',
        params: {
          policyNo: item.PoliceNo,
          revisionNo: '0',
          supplementNo: '0',
          renewalNo: item.YenilemeNo
        }
      })
    }
  },
  computed: {
    isPolicyNotExists: function () {
      return !this.policies || (this.policies && this.policies.length === 0)
    }
  }
}
</script>

<style scoped>
.notifications {
  position: relative;
  top: auto;
  pointer-events: all;
  min-height: calc(100vh - 64px);
}
.notifications .info-text {
  background-color: var(--light-bg2);
  height: 100%;
  padding: 10px 5px;
}
.notifications .info-text .info-text-detail-paragraph {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--text-color1);
  margin: auto 11px auto 11px;
}
.notifications .info-text .info-text-detail-paragraph .info-text-detail-header { 
  margin: 0 0 0.625em 0;
}
.notifications .info-text .info-text-detail-paragraph .read-all {
  margin-bottom: 10px;
}
.notifications .info-text .info-text-detail-paragraph .read-all a {
  font-size: 0.938em;
  font-weight: 500;
  text-decoration: underline;
  line-height: 1.29;
  letter-spacing: -0.3px;
  color: var(--text-color9) !important;
  text-align: center;
}
.notifications .policy-item {
  cursor: pointer;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/shared/widget/post/notifications.vue